import Funding from "../../pages/common/Funding";
import FundingExploreProject from "../../pages/common/FundingExploreProject";
import FundingProjectFullDetail from "../../pages/common/FundingProjectFullDetail";
import FundingSubmitProject from "../../pages/common/FundingSubmitProject";

export const fundingPaths = {
    Dashboard: "/funding/overview",
    ExploreProject: "/funding/explore-project",
    FundingSubmitProject: "/funding/submit-project",
    FundingProjectFullDetail: "/funding/project-detail",
};

export const AllFundingRoutes = [
    {
        name: "Funding",
        path: fundingPaths?.Dashboard,
        element: <Funding />,
        isPrivate: false,
    },
    {
        name: "FundingExploreProject",
        path: fundingPaths?.ExploreProject,
        element: <FundingExploreProject />,
        isPrivate: false,
    },

      {
        name: "FundingSubmitProject",
        path: fundingPaths?.FundingSubmitProject,
        element: <FundingSubmitProject />,
        isPrivate: false,
    },

      {
        name: "FundingProjectFullDetail",
        path: fundingPaths?.FundingProjectFullDetail,
        element: <FundingProjectFullDetail />,
        isPrivate: false,
    },

//       {
//         name: "FundingSubmitProject",
//         path: fundingPaths?.SubmitProject,
//         element: <undingSubmitProject />,
//         isPrivate: false,
//     },

//       {
//         name: "FundingSubmitProject",
//         path: fundingPaths?.SubmitProject,
//         element: <undingSubmitProject />,
//         isPrivate: false,
//     },
//   {
//         name: "FundingSubmitProject",
//         path: fundingPaths?.SubmitProject,
//         element: <undingSubmitProject />,
//         isPrivate: false,
//     },

];